import api from "./axios"; // твой axios instance

export const IntegrationsApi = {
  getAll() {
    return api.get("/integrations");
  },

  getOne(name: string) {
    return api.get(`/integrations/${name}`);
  },

  create(data: any) {
    return api.post("/integrations", data);
  },

  update(name: string, data: any) {
    return api.patch(`/integrations/${name}`, data);
  },

  delete(name: string) {
    return api.delete(`/integrations/${name}`);
  },
};
